import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { QuestionCreatorComponent } from './question-creator/question-creator.component';
import { NavbarComponent } from './commons/navbar/navbar.component';
import { FooterComponent } from './commons/footer/footer.component';
import { AppRoutingModule } from './app-routing.module';
import {MatCardModule} from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AngularEditorModule} from '@kolkov/angular-editor';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatDividerModule} from '@angular/material/divider';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatDialogModule} from '@angular/material/dialog';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { ListQuestionsComponent } from './list-questions/list-questions.component';
import { SubtypeCreationComponent } from './subtype-creation/subtype-creation.component';
import { ViewQuestionComponent } from './view-question/view-question.component';
import {MatTableModule} from '@angular/material/table';
import {MatRadioModule} from '@angular/material/radio';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatSidenavModule} from '@angular/material/sidenav';
import { AssessmentCreatorComponent } from './assessment-creator/assessment-creator.component';
import { AssessmentBuilderComponent } from './assessment-builder/assessment-builder.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { AssessmentAttemptComponent } from './assessment-attempt/assessment-attempt.component';
import { AssessmentRulesComponent } from './widgets/assessment-rules/assessment-rules.component';
import { AssessmentQuestionComponent } from './widgets/assessment-question/assessment-question.component';
import { LoginComponent } from './view/login/login.component';
// import { OtpComponent } from './view/otp/otp.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { ListUsersComponent } from './commons/list-users/list-users.component';
import { QualifiedRolesComponent } from './commons/qualified-roles/qualified-roles.component';
import { UserPerformanceDashboardComponent } from './commons/user-performance-dashboard/user-performance-dashboard.component';
import { SkillsRadarChartComponent } from './commons/skills-radar-chart/skills-radar-chart.component';
import { PercentileChartComponent } from './commons/percentile-chart/percentile-chart.component';
import { ProfessionScoreManagerComponent } from './profession-score-manager/profession-score-manager.component';
import { BehaviorCategoriesManagerComponent } from './behavior-categories-manager/behavior-categories-manager.component';
import { LoginPageComponent } from './view/login-page/login-page.component';
import { ParticleBackgroundComponent } from './view/particle-background/particle-background.component';
import { LoginCardComponent } from './view/login-card/login-card.component';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http'; 
import { AuthGuard } from './services/auth-gaurd.service';              
import { AuthInterceptor } from './services/auth.interceptor';          
import { ForgotPasswordCardComponent } from './view/forgot-password-card/forgot-password-card.component';
import { NewPasswordCardComponent } from './view/new-password-card/new-password-card.component';
import { InviteUserModalComponent } from './commons/invite-user-modal/invite-user-modal.component';
import { UserScoreDrawerComponent } from './commons/user-score-drawer/user-score-drawer.component';
import { RecruitmentShellComponent } from './recruitment/recruitment-shell/recruitment-shell.component';
import { RecruitmentDashboardComponent } from './recruitment/recruitment-dashboard/recruitment-dashboard.component';
import { BenchmarkListComponent } from './recruitment/benchmark-list/benchmark-list.component';
import { BenchmarkDetailComponent } from './recruitment/benchmark-detail/benchmark-detail.component';
import { CandidateListComponent } from './recruitment/candidate-list/candidate-list.component';
import { CandidateDetailComponent } from './recruitment/candidate-detail/candidate-detail.component';
import { JoinOrganizationComponent } from './recruitment/join-organization/join-organization.component';
import { ProfileComponent } from './profile/profile.component';

@NgModule({ declarations: [
        AppComponent,
        QuestionCreatorComponent,
        NavbarComponent,
        FooterComponent,
        ListQuestionsComponent,
        SubtypeCreationComponent,
        ViewQuestionComponent,
        AssessmentCreatorComponent,
        AssessmentBuilderComponent,
        AssessmentAttemptComponent,
        AssessmentRulesComponent,
        AssessmentQuestionComponent,
        AdminDashboardComponent,
        ListUsersComponent,
        LoginComponent,
        QualifiedRolesComponent,
        UserPerformanceDashboardComponent,
        SkillsRadarChartComponent,
        PercentileChartComponent,
        ProfessionScoreManagerComponent,
        BehaviorCategoriesManagerComponent,
        LoginPageComponent,
        ParticleBackgroundComponent,
        LoginCardComponent,
        ForgotPasswordCardComponent,
        NewPasswordCardComponent,
        InviteUserModalComponent,
        UserScoreDrawerComponent,
        RecruitmentShellComponent,
        RecruitmentDashboardComponent,
        BenchmarkListComponent,
        BenchmarkDetailComponent,
        CandidateListComponent,
        CandidateDetailComponent,
        JoinOrganizationComponent,
        ProfileComponent,
        // OtpComponent,
        
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        NgbModule,
        FormsModule, ReactiveFormsModule,
        AngularEditorModule,
        AppRoutingModule,
        MatCardModule,
        MatSelectModule,
        MatInputModule,
        MatDividerModule,
        MatIconModule,
        MatButtonModule,
        MatDialogModule,
        MatCheckboxModule,
        MatTableModule,
        MatRadioModule,
        MatSnackBarModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatExpansionModule,
        MatSidenavModule,
        MatButtonToggleModule,
        MatChipsModule,
        MatAutocompleteModule,
        NgOtpInputModule],
        
        providers: [provideHttpClient(withInterceptorsFromDi()),
            AuthGuard,        
            {
              provide:  HTTP_INTERCEPTORS,
              useClass: AuthInterceptor,
              multi:    true,           
            },

        ] })
export class AppModule { }
